import { Box, Flex, Link } from "@chakra-ui/react";
import { TopVisitedUrl } from "@intentsify/types";
import { toNumberDisplayValue } from "@intentsify/utils";
import { useQuery } from "@tanstack/react-query";
import { ColumnDef } from "@tanstack/react-table";
import { ParentSize } from "@visx/responsive";
import { Card, TableVirtualised } from "components";
import { Props } from "../../../../WebAnalytics.types";
import { getBuyingGroupTopVisitedUrls } from "../../Visualization.requests";

export const BuyingGroupTopVisitedUrls = ({
  pixelId,
  accountView,
  campaignId,
  startDate,
  endDate,
  accountsIds,
  visitedPages,
  includeIspTraffic,
  includeKnownBotTraffic,
  includePotentialBotTraffic,
  personas,
}: Props) => {
  const { data: data, isFetching: isFetching } = useQuery({
    queryKey: [
      "webAnalyticsBuyingGroupTopVisitedUrls",
      pixelId,
      accountView,
      campaignId,
      startDate,
      endDate,
      accountsIds,
      visitedPages,
      includeIspTraffic,
      includeKnownBotTraffic,
      includePotentialBotTraffic,
      personas,
    ],
    queryFn: () =>
      getBuyingGroupTopVisitedUrls(pixelId, {
        accountView,
        campaignId,
        startDate,
        endDate,
        accountsIds,
        visitedPages,
        includeIspTraffic,
        includeKnownBotTraffic,
        includePotentialBotTraffic,
        personas,
      }),
  });

  const columns: ColumnDef<TopVisitedUrl>[] = [
    {
      header: "URL Visited",
      accessorKey: "url",
      cell: (info) => {
        return (
          <Box fontSize="xs">
            <Link href={String(info.getValue())} isExternal>
              {String(info.getValue())}
            </Link>
          </Box>
        );
      },
    },
    {
      header: "Page Visits",
      accessorKey: "pageVisits",
      cell: (info) => {
        return (
          <Box fontSize="xs">
            {toNumberDisplayValue(Number(info.getValue()))}
          </Box>
        );
      },
    },
  ];
  return (
    <Card
      isLoading={isFetching}
      title="Top Visiting URLs from Buying Group"
      hasData={!isFetching && Boolean(data?.data.length)}
    >
      <ParentSize>
        {(parent) => {
          const { width, height } = parent;

          return (
            <Flex w={width} h={height}>
              <TableVirtualised
                isSortDisabled
                variant="corporateCompact"
                data={data?.data || []}
                columns={columns}
                containerProps={{
                  width: "100%",
                  maxHeight: "400",
                }}
              />
            </Flex>
          );
        }}
      </ParentSize>
    </Card>
  );
};
